/**
 * @param preferenceCenter {HTMLElement}
 * @param process {(smsCheckbox: HTMLInputElement) => void}
 * @return {void}
 */
module.exports = function forPreferenceCenterSmsCheckbox(preferenceCenter, process) {
    preferenceCenter.querySelectorAll('input[name="marketingSMSOptIn"]').forEach(smsCheckbox => {
        if (smsCheckbox instanceof HTMLInputElement) {
            process(smsCheckbox);
        }
    });
}
